// import Vue from 'vue'
// import VueI18n from 'vue-i18n'
// import { createI18n } from 'vue-i18n'

import { get as getParam } from "@/utils/query.ts";
import ar from "./ar.json";
import en from "./en.json";
import tr from "./tr.json";
import zh from "./zh_CN.json";
import tw from "./zh_TW.json";

// import fr from "./fr.json";
// import hi from "./hi.json";
// import id from "./id.json";
// import ja from "./ja.json";
// import ko from "./ko.json";
// import ms from "./ms.json";
// import my from "./my.json";
// import ra from "./ms.json";
// import th from "./th.json";
// import vi from "./vi.json";
// import vn from "./vn.json";

// Vue.use(VueI18n)
export let lang = (
  getParam("lang") ||
  navigator.language ||
  navigator.languages[0] ||
  "en"
).replace("_", "-");

if (lang.search(/zh/gi) !== -1) {
  lang = "zh_TW";
}

try {
  if (/\w+-\w+/.test(lang)) {
    const langs = lang.split("-");
    lang = `${langs[0]}-${langs[1].toUpperCase()}`;
  } else {
    lang = lang?.toLowerCase()
  }
} catch (error) {
  // ignore
}
window.document.documentElement.lang = lang;
const langs = {
  ar,
  en,
  tr,
  zh_CN: zh,
  zh_TW: tw,
};

export default langs[lang] || langs.en;


